import { appName } from "./Network/Config"

const setDocumentTitle = (title) =>{
    document.title = title + " - " + appName
}

export { setDocumentTitle }
